import Axios from "axios";
export default {
  fetch() {
    return Axios.get('/config.json');
  }
}
